// extracted by mini-css-extract-plugin
export default {"canvas":"Fireflies_canvas__45yeA"};